import * as React from 'react';
import cx from 'clsx';
import { Avatar } from '@repo/design-system-kit/components/avatar/avatar';
import { useThemedAssetPath } from '@repo/design-system-kit/hooks/use-themed-asset-path';
import sharedStyles from './shared-groups.module.css';
import styles from './addons-group.module.css';

export interface Addon {
  description: string;
  iconLightPath: string;
  iconDarkPath: string;
  isAvailable?: boolean;
}

export interface AddonsGroupProps {
  title: string;
  addons: Addon[];
}

function AddonListItem({
  description,
  iconLightPath,
  iconDarkPath,
  isAvailable = true,
}: Addon): React.ReactNode {
  const iconSrc = useThemedAssetPath(iconLightPath, iconDarkPath);

  return (
    <li
      className={cx(sharedStyles['list-item'], !isAvailable && styles['not-available'], 'mb-8')}
      data-testid="addon-description"
    >
      <span className={cx('mr-16', sharedStyles.image)}>
        <Avatar aria-hidden alt="" size="x-small" src={iconSrc} type="image" />
      </span>
      <span>{description}</span>
    </li>
  );
}

export function AddonsGroup({ title, addons }: AddonsGroupProps): React.ReactNode {
  return (
    <div>
      <h3 className={cx('body-prominent mb-8', sharedStyles.title)}>{title}</h3>
      <ul className={sharedStyles.list}>
        {addons.map(addon => (
          <AddonListItem key={addon.description} {...addon} />
        ))}
      </ul>
    </div>
  );
}
